import React from 'react';
import { Box } from '@mui/material';
import CustomMonthDatePicker from '../../../Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker';
import dayjs from 'dayjs';

const CONTROL_HEIGHT = '40px';

const toggleBtnStyle = (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    height: CONTROL_HEIGHT,
    minHeight: CONTROL_HEIGHT,
    padding: '0 16px',
    borderRadius: '8px',
    border: '2px solid #304FFF',
    background: active ? 'linear-gradient(135deg, #304FFF 0%, #1E40FF 100%)' : 'transparent',
    color: active ? '#ffffff' : '#304FFF',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
});

const ToggleButtons = ({
    autoFilling,
    setAutoFilling,
    t,
    direction,
    formData,
    reportingMonthDatePickerKey,
    handleReportingMonthDateChange,
    handleRegistrationMonthDateChange,
}) => {
    return (
        <Box
            dir={direction}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                mb: 1,
                gap: 1,
            }}
        >
            <div
                className="newDocument-container-button"
                style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
            >
                <button
                    type="button"
                    className={`newDocument-button ${autoFilling ? 'active' : ''}`}
                    onClick={() => setAutoFilling(true)}
                    style={toggleBtnStyle(autoFilling)}
                >
                    {t('Automatic Filling')}
                </button>
                <button
                    type="button"
                    className={`newDocument-button ${!autoFilling ? 'active' : ''}`}
                    onClick={() => setAutoFilling(false)}
                    style={toggleBtnStyle(!autoFilling)}
                >
                    {t('Manual Filling')}
                </button>
            </div>

            <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end' }}>
                <div style={{ minWidth: '140px' }}>
                    <div
                        style={{
                            fontSize: '0.875rem',
                            fontWeight: 500,
                            color: '#666666',
                            marginBottom: 4,
                        }}
                    >
                        {t('MonthReportDate')}
                    </div>
                    <CustomMonthDatePicker
                        key={reportingMonthDatePickerKey}
                        date={
                            formData?.reportingMonthDate
                                ? dayjs(new Date(formData.reportingMonthDate))
                                : null
                        }
                        onDateChange={(date) => {
                            if (date && handleReportingMonthDateChange) {
                                handleReportingMonthDateChange(date);
                            }
                        }}
                        height={CONTROL_HEIGHT}
                        disabled={false}
                    />
                </div>
                <div style={{ minWidth: '140px' }}>
                    <div
                        style={{
                            fontSize: '0.875rem',
                            fontWeight: 500,
                            color: '#666666',
                            marginBottom: 4,
                        }}
                    >
                        {t('RegistrationMonthDate')}
                    </div>
                    <CustomMonthDatePicker
                        date={
                            formData?.registrationMonthDate
                                ? dayjs(new Date(formData.registrationMonthDate))
                                : null
                        }
                        onDateChange={(date) => {
                            if (date && handleRegistrationMonthDateChange) {
                                handleRegistrationMonthDateChange(date);
                            }
                        }}
                        height={CONTROL_HEIGHT}
                        disabled={false}
                    />
                </div>
            </div>
        </Box>
    );
};

export default ToggleButtons;
